export default "__VITE_ASSET__D5C2_fCt__"